import React, { useEffect,useState } from "react";
import axios from "axios";
import { useAuth0 } from "../hooks/react-auth0-spa";

import { API_URL } from "../constants/constants";
import { Grid, Paper, CircularProgress, Typography } from "@material-ui/core";
// import clsx from "clsx";
import moment from "moment";

// import ChartEnviosPorMes from "../components/Charts/ChartEnviosPorMes";
// import ChartInversionPorMes from "../components/Charts/ChartInversionPorMes";
// import ChartEnviosPorFecha from "../components/Charts/ChartEnviosPorFecha";
// import ChartEnviosPorPaqueteria from "../components/Charts/ChartEnviosPorPaqueteria";
import Item from "../components/Item/Item";
// import useStyles from "./styles/stylesEstadisticas";
// import { useStatisticsAPI } from "../hooks/useEstadisticasAPI";
// import  useEnviosAPI  from "../hooks/useEnviosAPI";
// import { meses } from "../constants/constants";
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LineChart, Line, ResponsiveContainer,
} from 'recharts';

const Estadisticas = () => {
  // const classes = useStyles();
  // const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  const now = moment();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { getTokenSilently, user: user2 } = useAuth0();
  const [enviosHoy,setEnviosHoy]= useState(0);
  const [gastosHoy,setGastosHoy]=useState(0);
  const [enviosMes,setEnviosMes]= useState(0);
  const [gastosMes,setGastosMes]=useState(0);
  const paqueterias={
  fedex:{
    amount:0
  },  
  redpack:{
    amount:0
  },  
  paquetexpress:{
    amount:0
  },  
  sendex:{
    amount:0
  },  
  noventa9Minutos:{
    amount:0
  },  
  carssa:{
    amount:0
  },  
  ups:{
    amount:0
  },  
  estafeta:{
    amount:0
  },  
  quiken:{
    amount:0
  },  
  dostavista:{
    amount:0
  },  
  vencedor:{
    amount:0
  },  
  dhlWs:{
    amount:0
  },  
  ivoy:{
    amount:0
  },
  dhl:{
    amount:0
  },
  }
  const years={
    2019:{
      "01":{monto:0},
      "02":{monto:0},
      "03":{monto:0},
      "04":{monto:0},
      "05":{monto:0},
      "06":{monto:0},
      "07":{monto:0},
      "08":{monto:0},
      "09":{monto:0},
      "10":{monto:0},
      "11":{monto:0},
      "12":{monto:0},
    },
    2020:{
      "01":{monto:0},
      "02":{monto:0},
      "03":{monto:0},
      "04":{monto:0},
      "05":{monto:0},
      "06":{monto:0},
      "07":{monto:0},
      "08":{monto:0},
      "09":{monto:0},
      "10":{monto:0},
      "11":{monto:0},
      "12":{monto:0},
    }
  }
  // const 
  const [data,setData]=useState([]);

  const [cargos2020,setCargos2020]=useState([{}]);

  // const [cargos2019,setCargos2019]=useState([{}]);
  useEffect(() => {
    const fetchStatistics = async () => {
      setIsError(false);
      setIsLoading(true);
      try { 
        const t = await getTokenSilently();
        const r = await axios.get(API_URL + `/envios/${user2.sub}`, {
          headers: {
            // "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${t}`
          }
        });
      //  console.log(r.data)
       const info=r.data.data;
       const dateMoney=info.map(item=> ({fechaEnvio:new Date(item.fechaEnvio),monto:item.monto}));
       const today= new Date()
       const dia=today.getDate();
       const mes=today.getMonth();
       const year=today.getFullYear();
       let todayEnvios={
         envios:0,cantidad:0
       }
       let monthEnvios={
         envios:0,cantidad:0
       }
       dateMoney.forEach(item=>{
       
         if(item.fechaEnvio.getFullYear()===year&&item.fechaEnvio.getDate()===dia&&item.fechaEnvio.getMonth()===mes){
          todayEnvios.envios++;
          todayEnvios.cantidad+=item.monto;
         }
         if(item.fechaEnvio.getMonth()===mes&&item.fechaEnvio.getFullYear()===year){
           monthEnvios.envios++;
           monthEnvios.cantidad+=item.monto;
         }
       })
       setEnviosHoy(todayEnvios.envios);
       setEnviosMes(monthEnvios.envios);
       setGastosHoy(Math.round(todayEnvios.cantidad*100)/100);
       setGastosMes(Math.round(monthEnvios.cantidad*100)/100);
       info.forEach(element => {
         interpretarInfo(element)
       });
       let arrayPaq=[];
      for (let paq in paqueterias){
        if(paqueterias[paq].amount!==0){
          arrayPaq.push({name:`${paq}`,Envios:paqueterias[paq].amount})
        }
      }
      setData(arrayPaq)
      // years[2020].sort();
       setCargos2020([
        {name:'En',Dinero: Math.round(years[2020]["01"].monto*100)/100},
        {name:'Feb',Dinero: Math.round(years[2020]["02"].monto*100)/100},
        {name:'Mar',Dinero: Math.round(years[2020]["03"].monto*100)/100},
        {name:'Abr',Dinero: Math.round(years[2020]["04"].monto*100)/100},
        {name:'Ma',Dinero: Math.round(years[2020]["05"].monto*100)/100},
        {name:'Jun',Dinero: Math.round(years[2020]["06"].monto*100)/100},
        {name:'Jul',Dinero: Math.round(years[2020]["07"].monto*100)/100},
        {name:'Ag',Dinero: Math.round(years[2020]["08"].monto*100)/100},
        {name:'Sept',Dinero: Math.round(years[2020]["09"].monto*100)/100},
        {name:'Oct',Dinero: Math.round(years[2020]["10"].monto*100)/100},
        {name:'Nov',Dinero: Math.round(years[2020]["11"].monto*100)/100},
        {name:'Dic',Dinero: Math.round(years[2020]["12"].monto*100)/100}
       ])
      //  setCargos2019([
      //   {name:'En',Dinero:years[2019]["01"].monto},
      //   {name:'Feb',Dinero:years[2019]["02"].monto},
      //   {name:'Mar',Dinero:years[2019]["03"].monto},
      //   {name:'Abr',Dinero:years[2019]["04"].monto},
      //   {name:'Ma',Dinero:years[2019]["05"].monto},
      //   {name:'Jun',Dinero:years[2019]["06"].monto},
      //   {name:'Jul',Dinero:years[2019]["07"].monto},
      //   {name:'Ag',Dinero:years[2019]["08"].monto},
      //   {name:'Sept',Dinero:years[2019]["09"].monto},
      //   {name:'Oct',Dinero:years[2019]["10"].monto},
      //   {name:'Nov',Dinero:years[2019]["11"].monto},
      //   {name:'Dic',Dinero:years[2019]["12"].monto}
      //  ])

      } catch (error) {
        console.log(error);
        setIsError(true);
      }
      setIsLoading(false);
    };
    fetchStatistics();
    // eslint-disable-next-line
  }, []);
  const interpretarInfo=(item)=>{
    // console.table(item);
    //Nos importa la paqueteria [0]
    const paqueteria=item.paqueteria.split(" ")
    //Nos importan el año[0] y el mes[1] 
    const fecha=item.fechaEnvio.split("-")
    years[fecha[0]][fecha[1]].monto+=item.monto;
    paqueterias[paqueteria[0]].amount++
  }
  return isLoading || isError ? (
    <CircularProgress />
  ) : (
    
    <>
    <div style={{marginTop:20}}>
      <Grid container spacing={2}>
      <Grid item xs={6} md={3} lg={3}>
          <Item
            title="Envíos de Hoy"
            data={enviosHoy}
            footer={`Envíos realizados el: ${now.format("DD-MM-YYYY")}`}
          />
        </Grid>
        <Grid item xs={6} md={3} lg={3}>
          <Item
            title="Inversión de Hoy"
            data={gastosHoy}
            footer={`Envíos realizados el: ${now.format("DD-MM-YYYY")}`}
          />
        </Grid>
        <Grid item xs={6} md={3} lg={3}>
          <Item
            title="Envíos del Mes"
            data={enviosMes}
            footer={`Envíos realizados el: ${now.format("MM-YYYY")}`}
          />
        </Grid>
        
        <Grid item xs={6} md={3} lg={3}>
          <Item
            title="Inversión del Mes"
            data={gastosMes}
            footer={`Envíos realizados el: ${now.format("MM-YYYY")}`}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} >
        <Grid item xs={12} md={6} lg={6}>
        <Paper>
        <Typography  component="h2" variant="h6" color="primary" style={{fontSize:30,paddingTop:'30px',margin:'30px',textAlign:'center' }} gutterBottom>
          Paqueterias
        </Typography>
          <ResponsiveContainer width="90%" height={400}>
            <BarChart data={data}  margin={{top: 5, right: 30, left: 20, bottom: 5}}>
              <CartesianGrid  />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar  dataKey="Envios" fill="#8884d8" />
            </BarChart>
          </ResponsiveContainer>
            
          </Paper>
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
        <Paper >
        <Typography  component="h2" variant="h6" color="primary" style={{fontSize:30,paddingTop:'30px',margin:'30px',textAlign:'center' }} gutterBottom>
          Gastos 2020
        </Typography>
        <ResponsiveContainer width="90%" height={400}>
            <LineChart data={cargos2020}  
                  margin={{top: 5, right: 30, left: 20, bottom: 5}}>
            <XAxis dataKey="name"/>
            <YAxis/>
            <CartesianGrid strokeDasharray="3 3"/>
            <Tooltip/>
            <Legend />
            <Line type="monotone" dataKey="Dinero" stroke="#8884d8" activeDot={{r: 8}}/>
            </LineChart>
        </ResponsiveContainer>
              
          </Paper>
        </Grid>
        
      </Grid>
      
      </div>
    </>
  );
};

export default Estadisticas;
